import React from "react";
import PageTitle from "../../Components/PageTitle/PageTitle";
import Articles from "../../Components/Articles/Articles";

const Magazine = () => {
  return (
    <div>
      <PageTitle imgSrc="/images/titles/Magazine.svg"></PageTitle>
      <Articles />
    </div>
  );
};

export default Magazine;
